<template>
  <tabs-options-config v-if="quoteTo === 'cxTabs'" :options="options" :myid="myid" />
</template>

<script>
import tabsOptionsConfig from "../../tabs/toolbars/tabs-options-config"
export default {
  components: {
    tabsOptionsConfig,
  },
  props: {
    options: Object,
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      this1: this,
      activeNames: ["1", "2"],
      collapseActiveNames: [],
    }
  },
  computed: {
    quoteTo() {
      return this.options.quoteTo
    },
    ids() {
      return this.$store.state.states.activeID
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
  }
}
</script>
